import styles from '../styles/SlateEditor.module.scss';

export const toolbarHeight = 50;

const Toolbar = (props: { children?: React.ReactNode; rightContent?: React.ReactNode }) => {
    return <div className={styles.toolbar}>
        <div className={styles.toolbarLeft}>
            {props.children}
        </div>
        {props.rightContent && (
            <div className={styles.toolbarRight}>
                {props.rightContent}
            </div>
        )}
    </div>
};

export function ToolbarGroup(props) {
    return <div className={styles.toolbarGroup}>
        {props.children}
    </div>
}

export default Toolbar;
